// extracted by mini-css-extract-plugin
module.exports = {"form":"password-recovery-form_form__HBKtX account-auth_form__fQLY4","heading":"password-recovery-form_heading__EDPnJ confirm-dialog_heading__RtsPl"};